module.exports = __webpack_public_path__ + "img/file-upload.987e4668.svg";